import React from 'react'
import {OldMemberInfo} from '../repository/NatGetOwnershipTransfer'
import { Box, TableRow } from '@mui/material';
import {FontWeights} from '../../../../styledComponents/Constants'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    TableRowName,
    TableRowNameTop
} from '../../../../styledComponents/adminPage/Table'
import moment from 'moment'
import {getFormattedAddress} from '../../../common/util/Natutil'
import {Nullable} from '../../../../app/TypeHelpers'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {ROLE_FOR_ADMINISTRATOR} from '../../../../CodeMaster'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    oldMemberInfo: Nullable<OldMemberInfo>
}

export const NatOwnershipTransferApplyDetailByOldMember: React.FC<Props> = props => {
    const roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)
    const lmFlag = roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value

    if (!props.oldMemberInfo) {
        return (
            <TableRow>
                <TableRowName>
                    <Box fontWeight={FontWeights.Bold}>旧組合員</Box>
                </TableRowName>
                <SecondaryTableCell colSpan={4} end>
                    入力されていません。
                </SecondaryTableCell>
            </TableRow>
        )
    }

    const {
        oldMemberFamilyName,
        oldMemberFirstName,
        moveOutDate,
        phoneNumberAfterMoveOut,
        zipCodeAfterMoveOut,
        prefectureAfterMoveOut,
        address2AfterMoveOut,
        address3AfterMoveOut,
        buildingRoomNumberAfterMoveOut,
        oldMemberMailAddress,
    } = props.oldMemberInfo

    return (
        <>
            <TableRow>
                <TableRowNameTop rowSpan={oldMemberMailAddress && !lmFlag ? 5 : 4}>
                    <Box fontWeight={FontWeights.Bold}>旧組合員</Box>
                </TableRowNameTop>
                <SecondaryTableRowName>
                    旧組合員情報
                </SecondaryTableRowName>
                <SecondaryTableRowName>
                    氏名
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {oldMemberFamilyName} {oldMemberFirstName}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName>
                    退去予定日
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={3}>
                    {moment(moveOutDate).format('YYYY年M月D日')}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName rowSpan={oldMemberMailAddress && !lmFlag ? 3 : 2} end>
                    退去後の連絡先
                </SecondaryTableRowName>
                <SecondaryTableRowName>
                    電話番号
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {phoneNumberAfterMoveOut}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName end={!(oldMemberMailAddress && !lmFlag)}>
                    住所
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2} end={!(oldMemberMailAddress && !lmFlag)}>
                    {getFormattedAddress(
                        zipCodeAfterMoveOut,
                        prefectureAfterMoveOut,
                        address2AfterMoveOut,
                        address3AfterMoveOut,
                        buildingRoomNumberAfterMoveOut
                    )}
                </SecondaryTableCell>
            </TableRow>
            {oldMemberMailAddress && !lmFlag &&
                <TableRow>
                    <SecondaryTableRowName end>
                        メールアドレス
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={2} end>
                        {oldMemberMailAddress}
                    </SecondaryTableCell>
                </TableRow>
            }
        </>
    )
}